import React from 'react'
import PropTypes from 'prop-types'
import { useField } from 'formik'
import Checkbox from '../../Form/Checkbox/Checkbox'

const Component = ({
  value, setError, ...rest
}) => {
  const [field, meta] = useField({ value, ...rest })
  const hasError = meta.touched && meta.error
  setError(meta.error)
  return (
    <Checkbox
      {...field}
      {...rest}
      {...(hasError && ({ error: meta.error }))}
      value={value}
      checked={value}
    />
  )
}

Component.propTypes = {
  value: PropTypes.bool.isRequired,
  setError: PropTypes.func.isRequired
}

export default Component
